export default __webpack_public_path__ + "static/media/tete74.b36165c9.png";